// extracted by css-extract-rspack-plugin
var _1 = "EXWnX-i7vq6SFXpupnRQFA--";
var _2 = "TEN5aOmToyG-bu4CPd6w9A--";
var _3 = "Iqqiz2yngmVvtWGTNrhB3g--";
export { _1 as "description", _2 as "label", _3 as "p" }
